<template>
  <van-popup
    v-model="showRecords"
    position="bottom"
    :close-on-click-overlay="false"
    round
    close-on-popstate
    get-container="#app"
    :style="{
      height: '85%',
      display: 'flex',
      'flex-direction': 'column',
      overflow: 'hidden'
    }"
  >
    <div class="p-title-wrap">
      <p class="p-title">填报记录</p>
      <img src="../assets/images/icon-c.png" @click="handleCloseP"/>
    </div>
    
    <div class="p-wrap">
      <van-list
        v-if="rList && rList.length > 0"
        v-model="loading"
        :finished="finished"
      >
        <RecordItemNew v-for="item in rList" :key="item.id" :info="item"/>
      </van-list>
      <img class="p-wrap-img" v-else src="../assets/images/icon-no-r.png"/>
    </div>
  </van-popup>
</template>

<script>
import RecordItemNew from './RecordItemNew.vue'
import { get } from '@/commen/http'
export default {
  components: {
    RecordItemNew
  },
  props: {
    queryTime: {
      type: String
    }
  },
  data() {
    return {
      // 填报记录弹框
      showRecords: false,
      rList: [],
      loading: false,
      finished: false
    }
  },
  methods: {
    _show(id) {
      this.showRecords = true
      this.records(id)
    },
    handleCloseP() {
      this.showRecords = false
    },

    async records(id) {
      this.loading = true
      const res = await get({
        url: '/api/total/day/record',
        data: {
          reporterId: id,
          queryTime: this.queryTime
        }
      })
      if(res.code === 1) {
        this.rList = res.data;
        this.loading = false
        this.finished = true
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    }
  }
}
</script>

<style scoped>
.p-title-wrap {
  display: flex;
  align-items: center;
  padding: .3rem;
}
.p-title-wrap > img {
  width: .29rem;
  height: .29rem;
}
.p-wrap {
  box-sizing: border-box;
  padding: 0 .25rem;
  flex: 1;
  overflow-y: scroll;
}
.p-wrap-img {
  display: block;
  margin: 4rem auto 0 auto;
  width: 3.8rem;
  height: 3.26rem;
}
.p-title {
  flex: 1;
  font-size: .34rem;
  color: #333;
  font-weight: bold;
}
</style>